import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getSmevRequestFindResponse = (state: IRootState) => state.smevRequest.smevMessageResponse;
export const getSmevRequestRequestTypes = (state: IRootState) => state.smevRequest.requestType;
export const getSmevRequestRequestTemplates = (state: IRootState) => state.smevRequest.requestTemplates;
